<script setup>
const props = defineProps({
  name: {
    type: String,
    default: 'name',
  },
  theme: {
    type: String,
    default: undefined,
    validator(theme) {
      return ['conference'].includes(theme);
    },
  },
  gap: {
    type: String,
    default: undefined,
    validator(gap) {
      return ['small'].includes(gap);
    },
  },
});

const model = defineModel({ type: Boolean, default: false });

const { value, errorMessage, handleBlur } = useField(() => props.name, null, {
  type: 'checkbox',
  initialValue: model.value,
});

useSyncModels(model, value);

const toggleValue = useToggle(value);

const rootRef = ref(null);
const { focused } = useFocus(rootRef);
</script>

<template>
  <label
    ref="rootRef"
    class="form-checkbox"
    :class="{ [`form-checkbox--gap--${gap}`]: gap }"
    tabindex="0"
    @keyup.enter="toggleValue()"
    @blur="handleBlur($event, true)"
  >
    <input v-model="value" type="checkbox" hidden />

    <UiCheckbox
      class="form-checkbox__box"
      :is-checked="value"
      :is-error="!!errorMessage"
      :is-active="focused"
      :theme="theme"
    />

    <span class="form-checkbox__font form-checkbox__font--label">
      <slot />
    </span>
  </label>
</template>

<style scoped lang="scss">
.form-checkbox {
  $parent: &;

  cursor: pointer;
  display: flex;
  align-items: flex-start;
  gap: em(22);

  @include media-breakpoint-down(sm) {
    gap: em(16);
  }

  &__font {
    &--label {
      font-size: em(18);
      line-height: em(23, 18);
      font-weight: 250;

      @include media-breakpoint-down(sm) {
        font-size: em(16);
        line-height: em(21, 16);
      }
    }
  }

  &__box {
    flex-shrink: 0;
    margin-top: em(2);
  }

  &--gap {
    &--small {
      @include media-breakpoint-up(sm) {
        gap: em(10);
      }
    }
  }
}
</style>
